import React from "react";

const FooterComponent = () => {
  return (
    <footer className="footer-modern">
      <small>
        Designed by Duzie Uche-Abba &copy; 2022 -{" "}
        {new Date(Date.now()).getFullYear()}
      </small>
    </footer>
  );
};

export default FooterComponent;
